import { render, staticRenderFns } from "./BigUserPage.vue?vue&type=template&id=609b6a73&scoped=true"
import script from "./BigUserPage.vue?vue&type=script&lang=js"
export * from "./BigUserPage.vue?vue&type=script&lang=js"
import style0 from "./BigUserPage.vue?vue&type=style&index=0&id=609b6a73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609b6a73",
  null
  
)

export default component.exports